import { render, staticRenderFns } from "./SalesDashboardPage.vue?vue&type=template&id=4887814a&scoped=true&"
import script from "./SalesDashboardPage.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardPage.vue?vue&type=style&index=0&id=4887814a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4887814a",
  null
  
)

export default component.exports